export default __webpack_public_path__ + "3842d8daa003c0eca26a91b79d6a1501.jpg";